<template>
  <div class="line-content">
    <div class="flex-between">
      <div class="flex-align-center">
        <div class="title-2">提醒人次变化趋势</div>
      </div>
      <div class="flex-align-center">
        <!--时间标签-->
        <div class="flex-align-center tag-list">
          <div
            v-for="(item, index) in timeTagList"
            :key="index"
            :class="{ 'list-tag-item': true, 'active-tag': tagIndex == index }"
            @click="tagIndex = index"
          >
            {{ item }}
          </div>
        </div>
        <a-range-picker
          v-model="dateRange"
          :allow-clear="false"
          :getCalendarContainer="(node) => node.parentNode"
          style="width: 220px; margin: 0 15px"
        />
        <j-dict-select-tag
          style="width: 150px; margin-right: 15px"
          placeholder="请选择年级"
          v-model="queryParam.gradeId"
          dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
          :isShowEmpty="false"
          @select="$set(queryParam, 'classId', undefined)"
          @clear="$set(queryParam, 'classId', undefined)"
        />
        <!--<j-dict-select-tag-->
        <!--  style="width: 150px; margin: 0 15px"-->
        <!--  placeholder="请选择班级"-->
        <!--  v-model="queryParam.classId"-->
        <!--  :identityGet="`classDict,${queryParam.gradeId}`"-->
        <!--  :disabled="!queryParam.gradeId"-->
        <!--  :isShowEmpty="false"-->
        <!--/>-->
        <a-button type="primary" @click="getWeeklyReminderTrend(true)">查询</a-button>
      </div>
    </div>
    <div style="color: #666; margin-bottom: 10px;">
      *
      在这里可以查看每周的总提醒人数变化趋势，以便及时了解学校提醒人数的增加或减少的情况，做出相关管理干预
    </div>
    <BarChart
      v-if="isShowChart"
      height="260px"
      showAvgBtn
      :grid="grid"
      :fields="field"
      :dataSource="dataSource"
      :dataZoom="dataZoomConfig"
      :legend="legend"
    />
  </div>
</template>
<script>
import BarChart from '@/components/echartZyz/components/BarChart'
import { getAction } from '@api/manage'
import { handleLineChartData } from '@/utils/util'
import moment from 'moment'
import { getSchoolTerm } from '@/utils/termDate'
import { formatYearMonthDate, getMonthDateRange, getWeekDateRange } from '@/utils/date'

export default {
  name: 'ReminderNumCard',
  components: {
    BarChart,
  },
  props: {
    processRate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      field: [],
      dataSource: [],
      tagIndex: 1,
      dateRange: [],
      timeTagList: ['本月', '本学期'],
      queryParam: {},
      isShowChart: true, // 是否显示图表
      grid: {
        top: '10%',
        bottom: '28%',
        left: '5%',
        right: '5%',
      },
    }
  },
  computed: {
    dataZoomConfig() {
      // 本月数据比较少不用显示dataZoom，本学期数据太多需要显示
      return this.tagIndex ==0 
        ? false 
        : [{
          show: true,
          type: 'slider',
          height: 20,
          start: 0,
          end: 100,
        }];
    },
    legend() {
      return {
        orient: 'horizontal', // 横向排列
        left: 'center', // 水平居中
        top: 0, // 设置图例在顶部
        itemWidth: 12, // 图标宽度
        itemHeight: 12, // 图标高度
        symbol: 'rect', // 图标类型
      }
    },
  },
  watch: {
    tagIndex: {
      handler(val) {
        if (val == -1) return
        const { startDate, endDate } = getSchoolTerm()
        const dateRangObj = {
          0: getMonthDateRange(), // 本月日期范围
          1: [startDate, endDate], // 本学期日期范围
        }
        this.dateRange = dateRangObj[val]
        // 解决渲染问题
        this.getWeeklyReminderTrend()
      },
      immediate: true,
    },
  },
  methods: {
    // 提醒人次趋势
    async getWeeklyReminderTrend(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.tagIndex = -1
      }
      const dateRangeObj = {
        beginDate: formatYearMonthDate(this.dateRange[0]),
        endDate: formatYearMonthDate(this.dateRange[1]),
      }
      const res = await getAction('/AppTwo/getWeeklyReminderTrend', {
        type: 'curveData',
        ...this.queryParam,
        ...dateRangeObj,
      })
      const { success, result } = res
      if (success) {
        const filedMapList = [
          { name: '总提醒人数', field: 'totalWarnCount' },
          { name: '连续提醒', field: 'consecutiveWarnCount' },
          { name: '一、二、三级学生提醒', field: 'careWarnCount' },
          { name: '重点学生提醒', field: 'specialWarnCount' },
        ]
        const resArr = []
        filedMapList.forEach((currItem) => {
          const mapData = []
          result.forEach((item, index) => {
            if (item[currItem.field] != undefined) {
              mapData.push({
                id: item.id || '',
                name: currItem.name,
                value: item[currItem.field],
                create_time: item.date,
                realtime: item.date,
              })
            }
          })
          resArr.push(...mapData)
        })
        const { filedList, lineData } = handleLineChartData(resArr)
        this.dataSource = lineData
        this.field = filedList
        // 解决渲染问题，先false后true
        this.isShowChart = false
        this.$nextTick(() => {
          this.isShowChart = true
        })
      }
    },
  },
}
</script>
<style scoped lang="less">
.line-content {
  box-sizing: border-box;
  height: 350px;
  padding: 15px 30px;
  border-radius: 8px;
  background-color: #fff;
  .sub-title {
    margin-left: 10px;
    font-size: 14px;
    color: #666666;
    .rate {
      margin-left: 2px;
      font-size: 18px;
      font-weight: 600;
      color: #009dff;
    }
  }

  .tag-list {
    .list-tag-item {
      width: 54px;
      height: 24px;
      margin: 6px;
      line-height: 24px;
      text-align: center;
      background: #eff4fc;
      border-radius: 4px;
      color: #404040;
      font-size: 12px;
      cursor: pointer;
    }
    .active-tag {
      background: #009dff;
      color: #fff;
    }
  }
}
</style>
